var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomContainer', {
    staticClass: "new-modal-wrapper customs-tools patternMaker-wrapper",
    attrs: {
      "elementType": "section"
    }
  }, [_c('ModalHeader', {
    attrs: {
      "backDisabled": _vm.disableButtons,
      "closeDisabled": _vm.disableButtons,
      "headerImg": true,
      "includeBack": _vm.isBackButtonVisible,
      "modalTitle": _vm.translations.customPatternMakerTitle
    },
    on: {
      "backEvent": function backEvent($event) {
        return _vm.$modal.hide('patternMaker');
      },
      "closeEvent": _vm.closeAction
    }
  }), _c('CustomContainer', {
    attrs: {
      "customClass": "new-modal-main-views-wrapper",
      "elementType": "section"
    }
  }, [_c('CustomContainer', {
    attrs: {
      "customClass": "patternmaker-patternmaker-view-body",
      "elementType": "div"
    }
  }, [_c('CustomContainer', {
    attrs: {
      "customClass": "patternmaker-patternmaker-view-model-image",
      "elementType": "div"
    }
  }, [_c('CustomContainer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.previewImageDataIsReady,
      expression: "!previewImageDataIsReady"
    }],
    attrs: {
      "customClass": "patternmaker-patternmaker-view-spinner-custom",
      "elementType": "div"
    }
  }, [_c('base-spinner', {
    attrs: {
      "size": _vm.spinnerSize
    }
  })], 1), _c('CustomImage', {
    attrs: {
      "alt": _vm.pdm.product_name,
      "src": _vm.previewImageUrl
    },
    on: {
      "load": function load($event) {
        return _vm.setPreviewImageIsLoading(false);
      }
    }
  })], 1), _c('CustomContainer', {
    attrs: {
      "customClass": ['text-center', 'patternmaker-patternmaker-view-instructions', {
        'patternmaker-patternmaker-view-error': _vm.highligthSelectSwatchInstructions
      }],
      "elementType": "div"
    }
  }, [_c('CustomText', {
    style: "margin-bottom: 0px",
    attrs: {
      "customClass": "text-center",
      "elementType": "p",
      "text": _vm.translations.customCheckListInstructions
    }
  })], 1), _c('PatternMaker-swatches-carousel', {
    attrs: {
      "swatches": _vm.swatches,
      "current-swatch": _vm.currentSwatch,
      "enabled": _vm.previewImageDataIsReady,
      "slide-to-selected-item": _vm.slideToSelectedItems
    },
    on: {
      "swatch-selected": _vm.selectSwatch
    }
  }), _c('CustomContainer', {
    attrs: {
      "customClass": ['text-center', 'patternmaker-patternmaker-view-instructions', {
        'patternmaker-patternmaker-view-error': _vm.highligthSelectStickerInstructions
      }],
      "elementType": "div"
    }
  }, [_c('CustomText', {
    style: "margin-bottom: 0px",
    attrs: {
      "customClass": "text-center",
      "elementType": "p",
      "text": _vm.translations.customCheckListInstructions2
    }
  })], 1), _vm.enableStickerGroups ? _c('PatternMakerStickerTabs', {
    attrs: {
      "tabs": _vm.stickerGroups
    }
  }) : _vm._e(), _c('PatternMakerStickersCarousel', {
    attrs: {
      "stickers": _vm.stickers,
      "current-sticker": _vm.currentSticker,
      "enabled": _vm.previewImageDataIsReady,
      "slide-to-selected-item": _vm.slideToSelectedItems
    },
    on: {
      "sticker-selected": _vm.selectSticker
    }
  })], 1)], 1), _c('CustomContainer', {
    staticClass: "new-modal-button-nav"
  }, [_c('CustomContainer', {
    staticClass: "new-modal-button-nav-container gutter"
  }, [_c('CustomButton', {
    attrs: {
      "customClass": "button secondary patternmaker-patternmaker-view-cta patternmaker-button",
      "type": "button",
      "isDisabled": !_vm.previewImageDataIsReady,
      "keyTranslation": "customCheckCancel"
    },
    on: {
      "click": function click($event) {
        return _vm.closeModalOption('cancel');
      }
    }
  })], 1), _c('CustomContainer', {
    staticClass: "new-modal-button-nav-container gutter"
  }, [_c('CustomButton', {
    attrs: {
      "customClass": ['button primary patternmaker-patternmaker-view-cta patternmaker-button', {
        disabled: !_vm.currentSwatch || !_vm.currentSticker || !_vm.previewImageDataIsReady
      }],
      "type": "button",
      "isDisabled": !_vm.previewImageDataIsReady,
      "keyTranslation": "customCheckFinish"
    },
    on: {
      "click": function click($event) {
        return _vm.finish();
      }
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }